import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { useParams } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import { getUtenti } from '../../actions/auth';

const ListaUtenti = ({ auth: { utenti, loading }, alert, getUtenti }) => {


  useEffect(() => {
    getUtenti();
  }, [getUtenti]);

  if (loading || !utenti) {
    return <Spinner />;
  }


  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                <div className="lista-utenti-container">
            <h2>Gestione Utenti</h2>
            <table className="utenti-table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Cognome</th>
                  <th>Username</th>
                  <th>Password</th>
                  <th>Codice Dispositivo</th>
                </tr>
              </thead>
              <tbody>
                {utenti.map((u) => (
                  <tr key={u._id}>
                    <td>{u.nome || ''}</td>
                    <td>{u.cognome || ''}</td>
                    <td>{u.username}</td>
                    <td>{u.parola_codice}</td>
                    <td>{u.codiceDispositivo || '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
              </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

ListaUtenti.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  getUtenti: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
});

export default connect(mapStateToProps, { getUtenti })(ListaUtenti);